import { render, staticRenderFns } from "./configuracaoNotasFiscais.vue?vue&type=template&id=72b39f44&scoped=true"
import script from "./configuracaoNotasFiscais.vue?vue&type=script&lang=js"
export * from "./configuracaoNotasFiscais.vue?vue&type=script&lang=js"
import style0 from "./configuracaoNotasFiscais.vue?vue&type=style&index=0&id=72b39f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b39f44",
  null
  
)

export default component.exports